import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';

import { RssSourceComponent } from '../../../rss-source/rss-source.component';
import { PlaylistItemDTO } from '../../../../core/models/view-models/playlist-item-models/playlist-item-dto.model';
import { PlaylistDTO } from '../../../../core/models/view-models/playlist-models/playlist-dto.model';
import { RssTickerConfigs } from '../../../../core/models/entities/rss-ticker.type';
import { AppConstants } from '../../../../app.constants';

@Component({
  selector: 'tab-rss-ticker',
  standalone: true,
  imports: [
    FormsModule,
    MatToolbarModule,
    MatCheckboxModule,
    MatButtonModule,
    MatTooltipModule,
    RssSourceComponent
  ],
  templateUrl: './tab-rss-ticker.component.html',
  styleUrls: [
    './tab-rss-ticker.component.scss',
    '../../../modal-playlist-item/playlist-item-dialog.component.scss'
  ]
})
export class TabRssTickerComponent implements OnInit {
  @Input() playlistItem: PlaylistItemDTO;
  @Input() playlist: PlaylistDTO;

  @Output() submit = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  ngOnInit(): void {
    this.playlistItem.RssConfigs = this.playlistItem.RssConfigs || new RssTickerConfigs();
  }

  onSubmit() {
    this.playlistItem.PlaylistItemTitle = AppConstants.RSS_TICKER_ITEM_TITLE;
    this.playlistItem.TimerConfig = null;

    this.submit.emit();
  }
}
